import { createElement, isNullOrUndefined, updateCSSText } from '@syncfusion/ej2-base';
/**
 * Class which performs regular text measuring logic to find font height.
 */
export class Regular {
    /**
     * Gets module name.
     *
     * @returns {string} - the module name.
     */
    getModuleName() {
        return 'Regular';
    }
    /**
     * Constructor to initialize Regular module.
     *
     * @param {DocumentHelper} documentHelper - the document helper object
     */
    constructor(documentHelper) {
        this.documentHelper = documentHelper;
    }
    /**
     * @private
     * @param {WCharacterFormat} characterFormat - character format to apply.
     * @param {string} fontToRender - font to render.
     * @returns {TextSizeInfo} returns text size information.
     */
    getHeightInternal(characterFormat, fontToRender) {
        let textHeight = 0;
        let baselineOffset = 0;
        const spanElement = document.createElement('span');
        spanElement.innerText = 'm';
        const iframe = createElement('iframe');
        document.body.appendChild(iframe);
        const innerHtml = '<!DOCTYPE html>'
            + '<html><head></head>'
            + '<body>'
            + '</body>'
            + '</html>';
        if (!isNullOrUndefined(iframe.contentDocument)) {
            iframe.contentDocument.open();
            iframe.contentDocument.write(innerHtml);
            iframe.contentDocument.close();
        }
        this.applyStyle(spanElement, characterFormat, fontToRender);
        const parentDiv = document.createElement('div');
        parentDiv.style.cssText = 'display:inline-block;position:absolute;';
        const tempDiv = document.createElement('div');
        tempDiv.style.cssText = 'display:inline-block;width: 1px; height: 0px;vertical-align: baseline;';
        parentDiv.appendChild(spanElement);
        parentDiv.appendChild(tempDiv);
        iframe.contentDocument.body.appendChild(parentDiv);
        textHeight = spanElement.offsetHeight;
        const textTopVal = spanElement.offsetTop;
        const tempDivTopVal = tempDiv.offsetTop;
        baselineOffset = tempDivTopVal - textTopVal;
        document.body.removeChild(iframe);
        return { 'Height': textHeight, 'BaselineOffset': baselineOffset };
    }
    applyStyle(spanElement, characterFormat, fontToRender) {
        if (!isNullOrUndefined(spanElement) && !isNullOrUndefined(characterFormat)) {
            let style = 'white-space:nowrap;';
            if (!isNullOrUndefined(fontToRender) && fontToRender !== '') {
                style += 'font-family:' + fontToRender + ';';
            }
            else {
                style += 'font-family:' + characterFormat.fontFamily + ';';
            }
            const isBidi = characterFormat.bidi || characterFormat.complexScript;
            let fontSize = isBidi ? characterFormat.fontSizeBidi : characterFormat.fontSize;
            if (fontSize <= 0.5) {
                fontSize = 0.5;
            }
            style += 'font-size:' + fontSize.toString() + 'pt;';
            if (characterFormat.bold) {
                style += 'font-weight:bold;';
            }
            if (characterFormat.italic) {
                style += 'font-style:italic;';
            }
            updateCSSText(spanElement, style);
        }
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.documentHelper = undefined;
    }
}
